import {Injectable} from '@angular/core';
import {NavigationItem} from './navigation-item.interface';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor() {
    this.loadNavigation();
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: 'subheading',
        label: 'Dashboard',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'Home',
            route: '/home',
            icon: 'mat:dashboard',
            routerLinkActiveOptions: {exact: true},
            availableTo: ['CENTER', 'CENTER_BRANCH']
          }
        ]
      },
      {
        type: 'subheading',
        label: 'General',
        availableTo: ['CENTER'],
        children: [
          {
            type: 'dropdown',
            label: 'Branches',
            icon: 'mat:admin_panel_settings',
            availableTo: ['CENTER'],
            children: [
              {
                type: 'link',
                label: 'Add',
                route: '/general/branches/add',
                availableTo: ['CENTER']
              },
              {
                type: 'link',
                label: 'List',
                route: '/general/branches/list',
                availableTo: ['CENTER']
              }
            ]
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Phases',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'Stages',
            route: '/phases/stages',
            icon: 'mat:settings_overscan',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Leads',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'Manual',
            route: '/leads/manual',
            icon: 'mat:ballot',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Facebook',
            route: '/leads/facebook',
            icon: 'mat:thumb_up',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Messenger',
            route: '/leads/messenger',
            icon: 'mat:chrome_reader_mode',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Instagram',
            route: '/leads/instagram',
            icon: 'mat:add_a_photo',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Students',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'Add Students',
            route: '/students/add-student',
            icon: 'mat:person_add',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'List Students',
            route: '/students/list-students',
            icon: 'mat:diversity_3',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Verify Students',
            route: '/students/verify-student',
            icon: 'mat:person_search',
            availableTo: ['SUPER_ADMIN', 'ADMIN']
          },
          {
            type: 'link',
            label: 'Process Students',
            route: '/students/process-student',
            icon: 'mat:contact_emergency',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Process Bran. Students',
            route: '/students/process-branch-student',
            icon: 'mat:contact_emergency',
            availableTo: ['CENTER']
          },
          {
            type: 'link',
            label: 'All Students',
            route: '/students/all-students',
            icon: 'mat:auto_mode',
            availableTo: ['SUPER_ADMIN', 'ADMIN']
          },
          {
            type: 'link',
            label: 'Report',
            route: '/students/report',
            icon: 'mat:dashboard_customize',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Accounts',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'Process Transaction',
            route: '/accounts/process-transactions',
            icon: 'mat:add_card',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Instalment Transaction',
            route: '/accounts/instalment-transactions',
            icon: 'mat:card_membership',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Receipt Transaction',
            route: '/accounts/receipt-process-transactions',
            icon: 'mat:credit_card',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Wallet Transaction',
            route: '/accounts/wallet-transactions',
            icon: 'mat:account_balance_wallet',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Report',
            route: '/accounts/report',
            icon: 'mat:dashboard_customize',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Receipts',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'Add',
            route: '/receipt/add',
            icon: 'mat:post_add',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'List',
            route: '/receipt/list',
            icon: 'mat:format_align_left',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Branch\' Receipt',
            route: '/receipt/branch',
            icon: 'mat:receipt',
            availableTo: ['CENTER']
          },
          {
            type: 'link',
            label: 'Report',
            route: '/receipt/report',
            icon: 'mat:dashboard_customize',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
        ]
      }
      ,
      {
        type: 'subheading',
        label: 'Tickets',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'Admission',
            route: '/tickets/admission',
            icon: 'mat:contact_mail',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Leads',
            route: '/tickets/leads',
            icon: 'mat:contact_phone',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Others',
            route: '/tickets/other',
            icon: 'mat:local_library',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Report',
            route: '/tickets/report',
            icon: 'mat:dashboard_customize',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Notifications',
        availableTo: ['CENTER', 'CENTER_BRANCH'],
        children: [
          {
            type: 'link',
            label: 'List',
            route: '/notification/list',
            icon: 'mat:notifications',
            availableTo: ['CENTER', 'CENTER_BRANCH']
          },
          {
            type: 'link',
            label: 'Report',
            route: '/notification/report',
            icon: 'mat:dashboard_customize',
            availableTo: ['CENTER']
          },
        ]
      },
    ]);
  }
}
